/**
 * The documentation sidebar: every section, with the current one open to its
 * articles. Desktop only; phones get breadcrumbs and the section list.
 */
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { HELP_CENTER } from '@/content/help';
import HelpIcon from './HelpIcon';

export default function HelpSidebar({ sectionId, articleId }) {
  return (
    <nav aria-label="Help Center sections" className="text-[14px]">
      <p className="mb-3 text-[11px] uppercase tracking-[0.18em] text-white/40">Help topics</p>
      <ul className="space-y-0.5">
        {HELP_CENTER.sections.map((s) => {
          const open = s.id === sectionId;
          return (
            <li key={s.id}>
              <Link
                to={s.path}
                aria-current={open && !articleId ? 'page' : undefined}
                className={cn(
                  'flex items-center gap-2.5 rounded-lg px-2.5 py-2 transition-colors',
                  open ? 'bg-white/[0.06] text-white' : 'text-white/60 hover:bg-white/[0.04] hover:text-white',
                )}
              >
                <HelpIcon name={s.icon} className="h-4 w-4 flex-shrink-0 text-white/50" />
                <span className="min-w-0 truncate">{s.title}</span>
              </Link>
              {open && s.articles.length > 0 && (
                <ul className="mt-1 mb-2 ml-[18px] space-y-0.5 border-l border-white/10 pl-3">
                  {s.articles.map((a) => (
                    <li key={a.id}>
                      <Link
                        to={a.path}
                        aria-current={a.id === articleId ? 'page' : undefined}
                        className={cn(
                          'block rounded-md px-2 py-1.5 text-[13.5px] leading-snug transition-colors',
                          a.id === articleId ? 'text-white bg-white/[0.05]' : 'text-white/55 hover:text-white',
                        )}
                      >
                        {a.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
HelpSidebar.propTypes = { sectionId: PropTypes.string, articleId: PropTypes.string };
